import List from "@/components/list";
// import router from "@/router";
import vue from "@/main";

const Table = args => {
  const { listeners, props } = args;
  const RCSelectionChange = listeners["selection-change"] || function() {};

  const Deal = ({ props: { vo } }) => {
    const user = vo.row;
    const dealConf = [
      [
        props.status == 0 ? "icon-add-score-disabled" : "icon-add-score",
        "新增成绩",
        props.status == 0
          ? () => {}
          : () => {
              vue.$emit("addScore", user.uuid);
            },
        "examInfo:manual"
      ],
      ["icon-export", "导出成绩", () => {}, "examInfo:delete"]
    ];

    return (
      <div class="deal-group">
        {dealConf.map(item => (
          <el-tooltip content={item[1]} placement="top" v-permission={item[3]}>
            <i class={item[0]} onClick={item[2]}></i>
          </el-tooltip>
        ))}
      </div>
    );
  };
  const ExamResult = ({ props: { vo } }) => {
    const examResult = vo.row.examResult
    return <div domPropsInnerHTML={examResult}></div>;
  };
  const ReExamResult = ({ props: { vo } }) => {
    const reExamResult = vo.row.reExamResult
    return <div domPropsInnerHTML={reExamResult}></div>;
  };

  const AccountTableConfig = [
    {
      type: "selection",
      label: "main"
    },
    {
      label: "学员姓名",
      prop: "userName"
    },
    {
      label: "工作单位",
      prop: "deptName"
    },
    {
      label: "单位及职务",
      prop: "unitPosition"
    },
    {
      label: "最高分",
      prop: "maxScore"
    },
    {
      label: "获得学分",
      prop: "maxCredit"
    },
    {
      label: "考试成绩",
      prop: "examResult",
      minWidth: "200",
      render: vo => <ExamResult vo={vo} />
    },
    {
      label: "补考成绩",
      prop: "reExamResult",
      minWidth: "200",
      render: vo => <ReExamResult vo={vo} />
    },
    {
      label: "考试状态",
      prop: "userAnswerStatusName"
    },
    {
      label: "是否有效",
      prop: "isExistName"
    },
    {
      label: "考试次数",
      prop: "userExamNumStr"
    },
    {
      label: "补考次数",
      prop: "userReExamNumStr"
    },
    {
      label: "答题记录",
      minWidth: 150,
      render: e => {
        const item = e.row;
        return (
          <div>
            {item.answerBatchList.map(ele => {
              return (
                <el-tag
                  closable
                  size="mini"
                  style="margin: 3px"
                  type={ele.answerType == 1 ? "danger" : "default"}
                  onClose={() => {
                    vue.$emit("deleteExamRecord", ele.answerBatchId);
                  }}
                  onClick={() => {
                    vue.$emit("previewExamScore", ele.answerBatchId);
                  }}
                >
                  {ele.answerBatchName}
                </el-tag>
              );
            })}
          </div>
        );
      }
    },
    {
      label: "操作",
      fixed: "right",
      render: vo => <Deal vo={vo} />
    }
  ];
  if (props.examType == 0) {
    AccountTableConfig.splice(4, 0, {
      label: "必修课完成情况",
      prop: "finishStatusName"
    }, {
      label: "必修课完成进度",
      prop: "finishSchedule"
    })
  }
  return (
    <List
      {...args}
      onSelectionChange={RCSelectionChange}
      talbeCols={AccountTableConfig}
    />
  );
};

export default Table;
